import { RoundPhase } from "../constants/RoundPhase";
import { supabase } from "../supabase/supabase";
import { convertRoundPhaseToStatus } from "../utils/RoundPhaseUtils";

interface IRound {
    roundId?: number;
    game?: string;
    judge?: number;
    criminal?: number;
    redCardIdx?: number;
    status?: number;
    winningBlackCardIdx?: number;
    winner?: number;
    lastUpdateTime?: number
}

export class Round {
    roundId: number;
    game: string;
    judge: number;
    criminal: number;
    redCardIdx: number;
    status: number;
    winningBlackCardIdx: number;
    winner: number;
    lastUpdateTime: number

    constructor(roundId: number, game: string, judge: number, criminal: number, redCardIdx: number, status: number, winningBlackCardIdx: number, winner: number, lastUpdateTime: number) {
        this.roundId = roundId;
        this.game = game;
        this.judge = judge;
        this.criminal = criminal;
        this.redCardIdx = redCardIdx;
        this.status = status;
        this.winningBlackCardIdx = winningBlackCardIdx;
        this.winner = winner;
        this.lastUpdateTime = lastUpdateTime;
    }

    static fromJson(json: IRound) {
        return new Round(
            json.roundId ? json.roundId as number : 0,
            json.game ? json.game as string : "",
            json.judge !== undefined ? json.judge as number : 1,
            json.criminal ? json.criminal as number : 0,
            json.redCardIdx !== undefined ? json.redCardIdx as number : -1,
            json.status ? json.status as number : 0,
            json.winningBlackCardIdx !== undefined ? json.winningBlackCardIdx as number : -1,
            json.winner ? json.winner as number : 0,
            json.lastUpdateTime ? json.lastUpdateTime as number : 0,
        );
    }

    static async addNewRound(gameId: string) {
        const unixTime = Date.now();
        const { data, error } = await supabase
            .from("Rounds")
            .insert({
                roundId: 0,
                game: gameId,
                judge: 0,
                criminal: 0,
                redCardIdx: -1,
                status: 0,
                winningBlackCardIdx: -1,
                winner: 0,
                lastUpdateTime: unixTime,
            })
    }

    static async updateRound(id: number, gameId: string, judgeId: number, criminalId: number, roundRedCardIdx: number, roundPhase: RoundPhase) {
        const unixTime = Date.now();
        const roundStatus = convertRoundPhaseToStatus(roundPhase);
        const { error } = await supabase
            .from("Rounds")
            .update({
                roundId: id,
                judge: judgeId,
                criminal: criminalId,
                redCardIdx: roundRedCardIdx,
                status: roundStatus,
                lastUpdateTime: unixTime,
            })
            .eq("game", gameId);
    }

    static async updateRoundStatus(gameId: string, roundPhase: RoundPhase) {
        const unixTime = Date.now();
        const roundStatus = convertRoundPhaseToStatus(roundPhase);
        const { error } = await supabase
            .from("Rounds")
            .update({
                status: roundStatus,
                lastUpdateTime: unixTime,
            })
            .eq("game", gameId);
    }

    static async updateRoundWinner(gameId: string, roundPhase: RoundPhase, roundWinningBlackCardIdx: number, roundWinner: number) {
        const unixTime = Date.now();
        const roundStatus = convertRoundPhaseToStatus(roundPhase);
        const { error } = await supabase
            .from("Rounds")
            .update({
                status: roundStatus,
                winningBlackCardIdx: roundWinningBlackCardIdx,
                winner: roundWinner,
                lastUpdateTime: unixTime,
            })
            .eq("game", gameId);
    }

    static async getRound(gameId: string) {
        const rounds = [];
        const { data, error } = await supabase
            .from("Rounds")
            .select(`
                roundId,
                judge,
                criminal,
                redCardIdx,
                status,
                winningBlackCardIdx,
                winner,
                lastUpdateTime
                `)
            .eq("game", gameId);

        for (let idx = 0; idx < data!.length; idx++) {
            const round = this.fromJson(data![idx]);
            rounds.push(round);
        }

        if (rounds.length > 0) {
            return rounds[0]
        }
        return new Round(0, gameId, 0, 0, -1, 0, -1, 0, 0);
    }
}